import { ToastQueue } from '@react-stately/toast';
import type { ToastData } from './toast-component';

// There is a single global toast queue instance for the whole app, initialized lazily.
let globalToastQueue: ToastQueue<ToastData> | null = null;

export function getGlobalToastQueue(): ToastQueue<ToastData> {
  if (!globalToastQueue) {
    globalToastQueue = new ToastQueue({
      maxVisibleToasts: 1,
    });
  }

  return globalToastQueue;
}

// Used to clear toasts after each tests in Ember
export function clearToastQueue(): void {
  getGlobalToastQueue().visibleToasts.forEach(toast => {
    getGlobalToastQueue().close(toast.key);
  });
}
